import React from "react";
import "./number.scss";
import { INPUT_LIMITS } from "../input-limits";
function NumberInput({
  value,
  onChange,
  step = 1,
  min = 0,
  max = 100,
  unit = "px",
  label = "",
  resetValue,
  className,
  icon,
}) {
  value = Number(value);
  step = Number(step);

  if (isNaN(value)) {
    value = resetValue;
  }

  return (
    <div className="grigora-number-input-ui-kit flex justify-between items-center text-grigora-base">
      {label}
      <div className="editor-input-box w-1/2 bg-ui-light-white rounded-full px-3 flex items-center gap-1">
        <input
          type="number"
          name="paddingleft"
          className="w-full bg-ui-light-white outline-none px-2"
          value={value}
          onChange={(e) => {
            if (e.target.value > max) {
              e.target.value = max;
            } else if (e.target.value < min) {
              e.target.value = min;
            }
            onChange(e.target.value);
          }}
          min={min ? min : INPUT_LIMITS["number-input"].minlength}
          max={max ? max : INPUT_LIMITS["number-input"].maxlength}
          step={step}
        />
        <div>{icon}</div>
      </div>
    </div>
  );
}

export default NumberInput;
